const poStaManageEn = {
  poStaManageLang: {
    电站管理: 'Power station management',
    创建电站: 'Create a power station',
    电站状态: 'Station status',
    请输入电站名称: 'Please enter the name of the power station',
    查询: 'Query',
    重置: 'Reset',
    序号: 'Serial Number',
    电站名称: 'Name of power station',
    系统数量: 'Number of systems',
    电站类型: 'Type of power station',
    装机功率: 'Installed power',
    装机容量: 'Installed capacity',
    电站地址: 'Address',
    投运时间: 'Operation time',
    操作: 'Operation',
    查看: 'Examine',
    修改: 'Modification',
    是否确认删除电站操作: 'Are you sure to delete the power station?',
    删除: 'Delete',
    暂无数据: 'No data available',
    查看电站: 'View power station',
    基础信息: 'Basic information',
    更多信息: 'More information',
    电站图片: 'Picture of the power station',
    电站联系电话: 'Power station contact number',
    安装图片: 'Equipment installation pictures',
    并网点信息: 'Consolidation point information',
    有光伏: 'Photovoltaic',
    无光伏: 'No photovoltaics',
    有并网点: 'Parallel branch',
    无并网点: 'No branch',
    其它: 'Others',
    变压器信息: 'Transformer information',
    站点变压器容量: 'Station transformer capacity',
    安装人: 'Installer',
    安装人联系号码: 'Installer Contact Number',
    关闭: 'Close',
    全部: 'All',
    在线: 'Online',
    离线: 'Offline',
    修改电站: 'Modified power station',
    '电站创建完成后，需前往系统管理，选择对应系统分配到电站后，才可正常运行':
      'After the creation of the power station is completed, you need to go to the system management and select the corresponding system to be assigned to the power station before it can operate normally',
    创建电站后需绑定系统: 'After creating the power station, it is necessary to bind the system',
    电站业主: 'Power plant owner',
    请输入电站业主称呼: 'Please enter the name of the power plant owner',
    请输入电站联系电话: 'Please enter the power station contact number',
    请输入装机功率: 'Please enter the installed power',
    请输入装机容量: 'Please enter the installed capacity',
    选择日期: 'Please select a date',

    国家: 'Country',
    省: 'Province',
    市: 'City',
    区: 'District',
    详细地址: 'Detailed address',
    电站经纬度: 'Station latitude and longitude',
    获取经纬度: 'Acquire latitude and longitude',
    经度: 'Longitude',
    纬度: 'Latitude',
    重新获取: 'Reacquire',
    点击上传图片: 'Click to upload',
    提示: 'Hint',
    上传的图片大小不得超过5M支持PNGJPG格式最多可上传5张图片: 'The size of uploaded images should not exceed 5M, supporting PNG and JPG formats, and up to 5 images can be uploaded',
    示例说明: 'Example description',
    '请按照示例上传图片以达到更佳展示效果。（建议使用横图，主体部分位于中央区域）':
      'Please follow the example to upload pictures to achieve a better display effect. (Horizontal map is recommended, with the main body in the central area)',
    变压器容量: 'Transformer capacity',
    请输入变压器容量: 'Please enter the transformer capacity',
    变压器信息: 'Transformer information',
    请输入变压器信息: 'Please enter transformer information',
    请选择: 'Please select',
    请输入安装人称呼: 'Please enter the name of the installer',
    请输入安装人联系号码: 'Please enter the contact number of the installer',
    取消: 'Cancel',
    创建: 'Establish',
    经纬度: 'Longitude&Latitude',
    请输入地区: 'Please enter a region',
    确定: 'Confirm',
    请选择电站类型: 'Please select a power station type',
    装机功率数值范围大于0小于10000: 'The value greater than 0 and less than 10000',
    小数点后不允许超过3位: 'No more than 3 digits are allowed after the decimal point',
    装机容量数值范围大于0小于10000: 'The value greater than 0 and less than 10000',
    '站点变压器容量数值范围1-9999整数': 'The value must be an integer between 1 and 9999',
    不超过200个字符: 'No more than 200 characters',

    未匹配到地点: 'No match to the location!',
    未找到搜索结果: 'No search results found!',
    图片大小不可超过5M: 'Image size cannot exceed 5M',
    最多5张图片当前总数已超过请重新选择: 'Up to 5 images, the current total number has exceeded. Please reselect!',

    系统管理: 'System management',
    请输入系统编号系统名称ems编号: 'System number/system name/ems number',
    系统绑定: 'System binding',
    主从配置: 'Master-slave configuration',
    系统编号: 'System number',
    系统名称: 'System name',
    主从模式: 'Master/Slave mode',
    主从编号: 'Master/slave number',
    EMS编号: 'EMS number',
    额定功率: 'Rated power',
    额定容量: 'Rated capacity',
    标称电压: 'Nominal voltage',
    统计配置: 'Statistical allocation',
    是否确认解绑: 'Are you sure to unbind?',
    解绑: 'Unbind',
    共: 'Total：',
    项数据: '',
    暂无系统可点击系统绑定进行添加: 'There is currently no system available, you can click on the system binding to add it',
    查看系统: 'View system',
    未知: 'Unknown',
    主机: 'Master',
    从机: 'Slave',
    规格参数: 'Specification parameter',
    当前已选: 'Currently selected',
    项: '',
    已选系统: 'Selected system',

    冷却方式: 'Type of cooling',
    确认: 'Confirm',
    暂未选择系统: 'No system has been selected yet!',
    请确认是否绑定该系统到当前站点: 'Please confirm whether to bind the system to the current site!',
    当前主从配置只针对平台展示并不会更改实际主从模式配置: 'The current master-slave configuration is only for platform display and will not change the actual master-slave mode configuration.',
    输入编号: 'Enter the number',
    请输入: 'Please enter',
    暂不支持输入0: ' 0 input is not supported!',
    禁止输入重复编号: 'Prohibit entering duplicate numbers!',

    '开启统计配置时，建议选择充放电量都为0的时间点，请先确认EMS本地能耗计已清零！':
      'When starting the statistical configuration, it is recommended to select the time point when the charge and discharge amounts are 0. Please first confirm that the EMS local energy consumption meter has been cleared!',
    '开启统计配置时，请先确认EMS本地能耗计已清零！': 'Please confirm that the EMS local energy meter has been cleared before starting the statistical configuration!',
    基本信息: 'Basic information',
    系统: 'System',
    时区: 'Time zone',
    时区偏移量: 'Time zone offset',
    统计状态: 'Statistical state',
    '当前统计未开启，请先选择统计开始时间（建议选择充放电量都为0的时间点）':
      'The current statistics is not open, please select the start time of statistics first (it is recommended to select the time point when the charge and discharge amount are 0).',
    '请重新选择统计开始时间（建议选择充放电量都为0的时间点）': 'Please reselect the start time of statistics (it is recommended to select the time point when the charge and discharge are 0)',
    已开启: 'Open',
    统计开始时间: 'Statistics start time',
    选择日期时间: 'Selecting a date and time',
    上次选择时间: 'Time of last selection',
    重新选择: 'Reselect',

    原始数据: 'Row data',
    时间范围: 'Time frame',
    开始时间: 'Start time',
    结束时间: 'Finish time ',
    最多支持查看7日范围的数据: 'Up to 7 days of data are supported',
    '请确认是否开启统计？': 'Please confirm whether statistics is enabled?',
    '开启统计后，平台将按照设置的“统计开始时间”进行统计！': 'After statistics are enabled, the platform will make statistics according to the set "statistics start time"！',
    '请确认是否变更统计开始时间？': 'Please confirm whether to change the start time of statistics?',
    '变更后，平台将按照新设置的时间进行重新统计！': 'After the change, the platform will re-count according to the new set time!',
    充电: 'Charging',
    放电: 'Discharging',
    电量kWh: 'Electric/kWh',
    '时间范围只能选择1-7天': 'The time range can only be selected from 1-7 days',
    请选择统计开始时间: 'Please select the start time of statistics',
    统计开始时间未变更: 'The statistics start time has not changed',
    '开启统计时间失败!': 'Failed to enable time statistics!'
  }
}
export default poStaManageEn
